import { render } from "./AddAnAppointment.vue?vue&type=template&id=03bccb5e&ts=true"
import script from "./AddAnAppointment.vue?vue&type=script&lang=ts"
export * from "./AddAnAppointment.vue?vue&type=script&lang=ts"

import "./AddAnAppointment.vue?vue&type=style&index=0&id=03bccb5e&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__